const config = {
  fbpixels: [
    {
      name: 'istackfb',
      id: '397072497799863'
    },
    {
      name: 'digitalexicafb',
      id: '704627336603309'
    },
  ],
  gas: [
    {
      name: 'digitalexicaga', 
      id: 'UA-81636791-20',
      isDefault: true
    }
  ],
  activeCampaign: {
    url: 'https://api.istack.network/active-campaign'
  },
  gtm: {
    id: 'AW-647045391'
  },
  istracker: {
    pluginUrl: 'https://storage.googleapis.com/istrackers/istracker/production/istracker.utilities.js'
  }
};
module.exports  = config;